if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let BodyG = document.body;

    // Time loading function
    function cargarReloj(){

        // Haciendo uso del objeto Date() obtenemos la hora, minuto y segundo
        let fechahora = new Date();
        let hora = fechahora.getHours();
        let minuto = fechahora.getMinutes();
        let segundo = fechahora.getSeconds();

        let IconDay = document.getElementById('icon_day');

        if(hora >= 18 || hora <= 6) {
            //BodyG.classList.add('site-moon');
            IconDay.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="443.35213" height="438.2806" viewBox="0 0 443.35213 438.2806"><path d="M65.02985,373.31177c33.35901,33.39099,76.51599,55.254,123.17001,62.41,46.65601,7.15231,94.375-.78125,136.21002-22.64499,41.832-21.867,75.59003-56.51599,96.35199-98.90601,20.76599-42.39099,27.44897-90.30099,19.078-136.75-.98047-5.51559-5.74609-9.5547-11.34802-9.6172h-.13672c-5.53912,0-10.31598,3.8945-11.43799,9.3203-9.66022,46.94101-40.94501,86.55499-84.371,106.83002-43.42999,20.27701-93.883,18.828-136.07999-3.90231-42.19101-22.73401-71.15601-64.07401-78.11301-111.48999-6.95309-47.422,8.918-95.336,42.80899-129.23,6.72269-6.6758,14.05499-12.711,21.89499-18.023,4.61331-3.1562,6.34381-9.1367,4.125-14.266-2.21481-5.1289-7.75781-7.9688-13.215-6.7695C121.95514,11.69109,75.79913,41.46409,43.95714,84.14409,12.11314,126.8241-3.28487,179.54608,.58613,232.65409c3.8711,53.10901,26.746,103.04001,64.44099,140.66l.00272-.00232ZM128.30685,41.70179c-19.039,25.457-30.78101,55.617-33.97701,87.242-3.19141,31.625,2.28909,63.52299,15.855,92.26999,13.56599,28.746,34.703,53.254,61.14499,70.89801,26.44101,17.64099,57.18799,27.746,88.94101,29.23401,31.75,1.48831,63.30899-5.69919,91.285-20.793,27.97299-15.09,51.31198-37.51599,67.504-64.867-4.38672,45.71899-24.504,88.5-56.922,121.04001-32.414,32.539-75.117,52.82001-120.82001,57.383-45.703,4.5625-91.57001-6.87891-129.78-32.371-38.207-25.492-66.383-63.453-79.72299-107.39999-13.336-43.953-11.008-91.168,6.5898-133.59,17.59801-42.42599,49.375-77.43,89.90599-99.039l-.00378-.00702Z"/></svg>';
        } else {
            IconDay.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="450.77383" height="515.20402" viewBox="0 0 450.77383 515.20402"><path d="M225.38733,0c-9.27731,0-16.80099,7.5234-16.80099,16.801V106.40299c0,9.2773,7.5195,16.80099,16.80099,16.80099,9.27731,0,16.80099-7.52341,16.80099-16.80099V16.80099C242.18833,7.52369,234.66492,0,225.38733,0ZM15.73734,120.4c-5.37891,.37891-10.57401,3.37891-13.477,8.39841-4.6406,8.0352-1.9102,18.285,6.12501,22.92599l77.69901,44.80099c8.0352,4.64059,18.285,1.9102,22.92599-6.125,4.64059-8.0352,1.9102-18.285-6.125-22.92599L25.18635,122.67341c-3.0117-1.7383-6.2227-2.50391-9.4492-2.27341h.0002Zm416.85001,0c-2.40619,.19922-4.73828,.96875-7,2.27341l-77.69901,44.80099c-8.03519,4.64059-10.76599,14.89101-6.125,22.92599,4.64059,8.0352,14.89099,10.76601,22.92599,6.125l77.69897-44.80099c8.03522-4.64059,10.76599-14.89101,6.125-22.92599-2.89838-5.02341-8.09381-8.0195-13.47699-8.39841-.80859-.05859-1.64838-.06641-2.44922,0h.00024Zm-207.20001,42c-52.379,0-95.19901,42.82001-95.19901,95.19901s42.82001,95.19901,95.19901,95.19901,95.19901-42.82001,95.19901-95.19901-42.82001-95.19901-95.19901-95.19901Zm0,33.60201c34.21899,0,61.60199,27.379,61.60199,61.60201,0,34.21899-27.379,61.60199-61.60199,61.60199-34.21899,0-61.60199-27.379-61.60199-61.60199,0-34.21899,27.379-61.60201,61.60199-61.60201Zm-132.3,120.40001c-2.4062,.20312-4.7383,.96875-7,2.27341L8.38834,363.47642c-8.0352,4.64059-10.766,14.89099-6.125,22.92599,4.64059,8.03519,14.89101,10.76599,22.92599,6.125l77.69901-44.80099c8.0352-4.64059,10.76601-14.89099,6.125-22.92599-2.89841-5.02341-8.0938-8.0195-13.47701-8.39841-.80859-.05469-1.64841-.06641-2.4492,0h.0002Zm262.14998,0c-5.37891,.37891-10.57401,3.37891-13.47699,8.39841-4.64059,8.03519-1.91019,18.285,6.125,22.92599l77.69897,44.80099c8.03522,4.64059,18.28497,1.91019,22.92603-6.125,4.64062-8.03519,1.91022-18.285-6.125-22.92599l-77.69901-44.80099c-3.01169-1.73831-6.22269-2.50391-9.44919-2.27341h.00018Zm-129.85001,75.59799c-9.27731,0-16.80099,7.5195-16.80099,16.80099v89.60199c0,9.27728,7.5195,16.80103,16.80099,16.80103,9.27731,0,16.80099-7.52338,16.80099-16.80103v-89.60199c0-9.27731-7.52341-16.80099-16.80099-16.80099Z"/></svg>';
        }

        // Variable meridiano con el valor 'AM'
        let meridiano = "am";

        // Si la hora es igual a 0, declaramos la hora con el valor 12
        if(hora == 0){
            hora = 12;
        }
        // Si la hora es mayor a 12, restamos la hora - 12 y mostramos la variable meridiano con el valor 'PM'
        if(hora > 12) {

            hora = hora - 12;
            // Variable meridiano con el valor 'PM'
            meridiano = "pm";

        }

        // Formateamos los ceros '0' del reloj
        hora = (hora < 10) ? "0" + hora : hora;
        minuto = (minuto < 10) ? "0" + minuto : minuto;
        segundo = (segundo < 10) ? "0" + segundo : segundo;

        // Enviamos la hora a la vista HTML
        let tiempo = hora + ":" + minuto + " " + meridiano;
        document.getElementById("date_header").innerText = tiempo;
        document.getElementById("date_header").textContent = tiempo;
        setTimeout(cargarReloj, 6000);

    }
    cargarReloj();

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false
    });

    $('.images-slides figure').attr('aria-hidden', false);

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-bg-content').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        accessibility: false
    });

    $('.selection-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true
    });

    $('.reviews-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true
    });

    $('.slider-slide-tag').slick({
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.m-slider-tag').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true,
        focusOnSelect: true
    });

    $('.hours-slide').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        accessibility: true,
        responsive: [
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true,
                }
            }
        ]
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    /** Function to add alt text to fancybox images **/

    $('[data-fancybox]').fancybox({
        afterShow: function(instance, current) {
            var alt = current.opts.$orig.data('alt');
            var img = current.$content ? current.$content.find('img.fancybox-image') : null;
    
            if (img && img.length) {
                if (alt) {
                    img.attr('alt', alt);
                }
                img.attr('tabindex', '0');
            }
        }
    });
    

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))").click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

    let screenHeight = $(window).height();
    $('.top-img figure, .top-img video').css("height", screenHeight);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('.top-img figure, .top-img video').css("height", screenHeight);
    });

    $("input[name*=select_destination]").eq(0).attr("checked", "checked");

    $("#menu_properties").click(function(){
        $('#links_properties').fadeToggle();
        $(this).toggleClass('open');
    })


})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
    const menu = document.querySelector('#navigationBox');
    const booking = document.querySelector('#bookBox');
    const isMenuVisible = menu && menu.classList.contains('open');
    const isBookingVisible = booking && booking.classList.contains('open');
    const elementsMenu = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
    const elementsBooking = document.querySelectorAll('#booking-form .form-content input, #booking-form .form-content select' );
    const closeMenuButton = document.querySelector('.close-icon');

    elementsMenu.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
    elementsBooking.forEach(element => {
        element.setAttribute('tabindex', isBookingVisible ? '0' : '-1');
    });
    const elementsToHide = document.querySelectorAll ('#find_open a, .logo-header a, .header-phone a, .book-header button');
    elementsToHide.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '-1' : '0');
    });

    closeMenuButton.addEventListener('click', () => {
        const firsrHeaderElement = header.querySelector('#find_open a');
        if (firsrHeaderElement){
            firsrHeaderElement.focus();
        }
    });
}
document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#navigationBox');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
    const booking = document.querySelector('#bookBox');
    if (booking) {
        booking.addEventListener('transitionend', updateMenuTabIndex);
    }
});

/* Keyboard Navigation for Menu */
document.addEventListener('keydown', function(e) {
    const target = e.target;
    const isMenuElement = target.classList.contains('menu-item-tab') || target.classList.contains('category-btn');

    if ((e.key === 'Enter') && isMenuElement) {
        e.preventDefault();
        target.click();
    }
});

/* Focus on Main Content when Using "Skip to content" with the keyboard */
document.addEventListener('DOMContentLoaded', function () {
    const skipLink = document.querySelector('a[href="#intro"]');
    const mainContent = document.getElementById('intro');

    if (skipLink && mainContent) {
        skipLink.addEventListener('keydown', function (e) {
            console.log('test',mainContent)
        if (e.key === 'Enter') {
            e.preventDefault();
            mainContent.setAttribute('tabindex', '-1');
            mainContent.focus();
            }
        });
    }
});
